import React, { useContext } from 'react';
import { Trans } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { URLS } from '@wix/da-url';
import UserSymbol from '../../../User/_partials/UserSymbol';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './NeedMoreFragments.scss';
const NeedMoreFragments = ({ hasCore, coreLevel, badgeTitle })=>{
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(Section, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: s['heading']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "coreBadge.awardBadgeModal.insufficient"
    }, "You need more fragments to award the ", {
        badgeTitle
    }, " badge.")), /*#__PURE__*/ React.createElement("p", null, hasCore && /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: `coreBadge.awardBadgeModal.needsMoreFragments.how.bullet1.${coreLevel}`
    }, "As a ", /*#__PURE__*/ React.createElement(UserSymbol, {
        userSymbol: coreLevel || 'core_access'
    }), " Core member, you get 300 fragments monthly."), !hasCore && /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "coreBadge.awardBadgeModal.needsMoreFragments.how.bullet1.noCorex"
    }, "Want more?", ' ', /*#__PURE__*/ React.createElement("a", {
        href: URLS.CORE_MEMBERSHIP
    }, /*#__PURE__*/ React.createElement(CoreSymbol, {
        corePackage: "core_access",
        size: IconSize.SMALL
    }), ' ', "Upgrade to Core"), "!")), /*#__PURE__*/ React.createElement("p", null, hasCore && !isMobile && /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "coreBadge.awardBadgeModal.needsMoreFragments.how.bullet2.core"
    }, "Want even more?", ' ', /*#__PURE__*/ React.createElement("strong", null, "Win them through DeviantArt contests and challenges!")), !hasCore && !isMobile && /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "coreBadge.awardBadgeModal.needsMoreFragments.how.bullet2.noCore"
    }, "You can also get them through DeviantArt contests and challenges.")));
};
NeedMoreFragments.displayName = 'NeedMoreFragments';
export default NeedMoreFragments;

//# sourceMappingURL=NeedMoreFragments.js.map